(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsV2Controller', CompanyServantsV2Controller);

    CompanyServantsV2Controller.$inject = ['$scope', '$state', 'Servant', 'ServantSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServantCustom', 'CompanyCustom', '$translate', 'Principal', 'DialogService', 'ActivityTypeInfoCustom', '$uibModal', 'QueryParamsService'];

    function CompanyServantsV2Controller($scope, $state, Servant, ServantSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServantCustom, CompanyCustom, $translate, Principal, DialogService, ActivityTypeInfoCustom, $uibModal, QueryParamsService) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.isWorkSpace = false;
        vm.servantTranslate = $translate.instant('tikonApp.servant.home.title');
        vm.newServantClick = newServantClick;


        vm.editServant = editServant;
        vm.searchServants = searchServants;
        vm.searchKeyPress = searchKeyPress;
        vm.newServant = newServant;
        vm.clearSearch = clearSearch;
        vm.showEducation = showEducation

        loadAll();
        loadPage();

        function loadAll() {


        }

        function loadPage(page) {
            //vm.page = page;
            //vm.transition();

            //if($ctrl.companyId==undefined || $ctrl.companyId==null)$ctrl.priceInfos=[];
            //else
            CompanyCustom.getCurrentCompany().query(function (result) {
                
                ActivityTypeInfoCustom.getActivityTypeInfoByType(result.activityType).query(function (activity) {
                    if (activity && activity.servantType == "RESOURCE") {
                        vm.isWorkSpace = true;
                    }
                    setServantTranslate();
                })
                
            });
            
            loadServants();
        }
        
        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function setServantTranslate() {

            if (vm.isWorkSpace) {
                vm.servantTranslate = $translate.instant('tikonApp.servant.home.title-space-v2');
            }
        }

        function newServantClick() {
            var result;
            if (vm.servants) {
                result = Principal.canAddNewServant(vm.servants.length);
                if (result) {

                } else {
                    DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                    return;
                }
            }

            $state.transitionTo('supplierPanel.companyServants.new');

        }

        function loadAccessToAddNew() {
            var _company = Principal.getCurrentCompany();
            if (_company && _company.id) {
                PackageFeatureListCustom.getPackageFeatureListByCompanyId(_company.id).query().$promise.then(function (result) {
                    Principal.setCurrentCompanyFeatureList(result);
                });
            }
        }


        function editServant(servant) {
            $state.go('supplierPanel-v2.companyServants.edit', {id: servant.id});
        }

        function newServant() {
            var result;
            if (vm.servants) {
                result = Principal.canAddNewServant(vm.servants.length);
                if (result) {

                } else {
                    DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                    return;
                }
            }

            $state.go('supplierPanel-v2.companyServants.new');
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                searchServants();
            }
        }

        function loadServants() {
            ServantCustom.findServantsByCompany().query().$promise.then(function(res) {
                vm.servants = res;
                var newFilters = QueryParamsService.getFilters();
                if(newFilters.searchText){
                        vm.searchQuery = newFilters.searchText;
                        searchServants()
                }
            })
        }

        function searchServants() {
            if (!vm.searchQuery) {
                 QueryParamsService.removeFilter('searchText')
                loadServants();
                return;
            }else  QueryParamsService.updateFilter('searchText', vm.searchQuery)
            vm.servants = vm.servants.filter(function (srv) {
                if (srv.personInfo.fisrtName.includes(vm.searchQuery) ||
                    srv.personInfo.lastName.includes(vm.searchQuery) ||
                    (srv.personInfo.phoneNumber && srv.personInfo.phoneNumber.includes(vm.searchQuery))

                )
                    return true;
            })
        }

        function clearSearch() {
            vm.searchQuery = null;
            QueryParamsService.removeFilter('searchText')
            loadServants();
        }
        function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="34479560706"><script type="text/JavaScript" src="https://www.aparat.com/embed/yiywlpx?data[rnddiv]=34479560706&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>'
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }

    }
})();
